import * as React from 'react'
// constants
import { Modals } from 'constants/index'
// hooks
import { useShowModal } from 'hooks/index'
// types
import { ISecurityProfilePermissions } from 'types/graphql'

type Props = React.PropsWithChildren<unknown>

interface IContext {
  handleActionClick: (data: { id: string; parentPermissions: ISecurityProfilePermissions }) => () => Promise<void>
  handleKPIClick: (data: { id: string; parentPermissions: ISecurityProfilePermissions }) => () => Promise<void>
  handleObjectiveClick: (data: { id: string; parentPermissions: ISecurityProfilePermissions }) => () => Promise<void>
}

export const ObjectivesListNavigationBLContext = React.createContext<IContext>({} as any)

const ObjectivesListNavigationBL: React.FC<Props> = ({ children }) => {
  // redux
  const { hideModal: hideActionModal, showModal: showActionModal } = useShowModal({
    modalType: Modals.ACTION_MINIMIZED_MODAL
  })
  const { hideModal: hideKPIModal, showModal: showKPIModal } = useShowModal({ modalType: Modals.KPI_MINIMIZED_MODAL })
  const { hideModal: hideObjectiveModal, showModal: showObjectiveModal } = useShowModal({
    modalType: Modals.OBJECTIVE_MINIMIZED_MODAL
  })

  // methods
  const handleObjectiveClick =
    ({ id, parentPermissions }) =>
    async () => {
      hideActionModal()
      hideKPIModal()
      showObjectiveModal({ id, parentPermissions })
    }

  const handleActionClick =
    ({ id, parentPermissions }) =>
    async () => {
      hideKPIModal()
      hideObjectiveModal()
      showActionModal({ id, parentPermissions })
    }

  const handleKPIClick =
    ({ id, parentPermissions }) =>
    async () => {
      hideActionModal()
      hideObjectiveModal()
      showKPIModal({ id, parentPermissions })
    }

  const value = { handleActionClick, handleKPIClick, handleObjectiveClick }

  return (
    <ObjectivesListNavigationBLContext.Provider value={value}>{children}</ObjectivesListNavigationBLContext.Provider>
  )
}

export default ObjectivesListNavigationBL
